{
  "mailValidator": "Feil format på e-post.",
  "binoMailForbidden": "Du kan ikke registrere deg med din BI-epostadresse. Vennligst bruk din private epostadresse.",
  "email": "Privat e-post",
  "password1": "Passord",
  "password2": "Bekreft passord",
  "password1Validator": "Passordet må ha minst 12 tegn og ha minimum et tall eller spesialtegn",
  "password2Validator": "Passordene er ikke like",
  "login": "Logg inn i Studentportalen",
  "reqTitle": "Passordet må bestå av:",
  "newPasswordReq1": "Minimum 12 tegn",
  "newPasswordReq2": "Må inneholde",
  "newPasswordReq2a": "Store og små bokstaver",
  "newPasswordReq2b": "Tall og spesialtegn (!@#$%^&*)",
  "TryAgainLink": "Trykk her for å prøve igjen"
}
